@if (showGeneratorSpotlight$ | async) {
  <div class="tw-mb-4">
    <bit-spotlight
      [title]="'generatorNudgeTitle' | i18n"
      (onDismiss)="dismissGeneratorSpotlight(NudgeType.GeneratorNudgeStatus)"
    >
      <p class="tw-text-main tw-mb-0" bitTypography="body2">
        <span class="tw-sr-only">
          {{ "generatorNudgeBodyAria" | i18n }}
        </span>
        <span aria-hidden="true">
          {{ "generatorNudgeBodyOne" | i18n }} <i class="bwi bwi-generate"></i>
          {{ "generatorNudgeBodyTwo" | i18n }}
        </span>
      </p>
    </bit-spotlight>
  </div>
}
